import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const AccountBillingGroupsShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

AccountBillingGroupsShow.query = gql`
  query GET_ONE($id: Int!) {
    accountBillingGroup(id: $id) {
      id
      created_at
      updated_at
    }
  }
`;

export default AccountBillingGroupsShow;
